import { cva } from 'class-variance-authority'

export const styles = cva(
  `
    inline-flex
    items-center
    justify-center
    rounded-lg
    text-sm
    font-medium
    cursor-pointer
    gap-2
    transition-[background-color] duration-150 ease-in-out
    shrink-0
    whitespace-nowrap
    break-words
    ring-offset-background
    focus-visible:outline-none
    focus-visible:ring-2
    focus-visible:ring-ring
    focus-visible:ring-offset-2
    disabled:pointer-events-none
    disabled:opacity-50 
    [&_svg]:pointer-events-none
    [&_svg]:size-4
    [&_svg]:shrink-0
  `,
  {
    variants: {
      variant: {
        primary: `
          bg-gradient-to-t
          from-neutral-800/90
          to-neutral-600/90
          hover:from-neutral-800
          hover:to-neutral-600
          active:from-neutral-600
          active:to-neutral-800
          border
          border-neutral-900
          text-neutral-0
        `,
        secondary: `
          bg-gradient-to-t
          to-neutral-0
          from-neutral-25
          hover:from-neutral-100
          hover:to-neutral-0
          active:from-neutral-0
          active:to-neutral-100
          disabled:bg-neutral-0
          text-neutral-700
          border-1
          border-neutral-200
        `,
        ghost: `
          bg-transparent
          hover:bg-neutral-50
          active:bg-neutral-100
          disabled:bg-neutral-0
          text-neutral-700
        `,
        danger: `
          bg-gradient-to-t
          from-danger-100/90
          to-danger-100
          hover:from-danger-100
          hover:to-danger-100/90
          active:from-danger-100/80
          active:to-danger-100
          disabled:bg-neutral-900/70
          text-neutral-0
        `,
        link: `
          underline
          text-neutral-900
          hover:text-brand
          active:text-neutral-600
        `,
        pagination: `
          bg-neutral-0
          text-neutral-900
          hover:bg-neutral-50
          hover:border-neutral-200
          border-1
          border-neutral-200
          active:bg-neutral-100
          active:border-neutral-200
          disabled:bg-neutral-0
        `,
        discreet: `
          text-neutral-500
          active:text-neutral-600
        `,
        dashed: `
          bg-transparent
          border
          border-dashed
          border-neutral-400
          text-neutral-700
          hover:border-neutral-600
          hover:text-neutral-900
          active:border-neutral-700
          active:text-neutral-900
          disabled:bg-transparent
        `,
      },
      size: {
        xs: 'h-7 px-2 text-[10px]',
        sm: 'h-8 px-3 text-xs',
        md: 'h-10 px-4 py-2 text-sm',
        lg: 'h-10 px-6 text-base',
        square: 'h-8 w-8',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  }
)

export const iconLeftStyles = cva(
  `
    left-3
    text-grey-500
    text-center
  `,
  {
    variants: {
      loading: {
        true: `
          animate-spin
          pl-5
          pr-5
        `,
      },
    },
  }
)
